module.exports = __webpack_public_path__ + "images/ios_device_icon.svg";